import { Map } from 'immutable';

/**
 * Build the config key from transaction type and RTL direction.
 * LTR (default): "ACCPAY" — backwards compatible with existing configs.
 * RTL: "ACCPAY_rtl"
 */
export const buildConfigKey = (transactionType: string, rtl: boolean): string =>
  rtl ? `${transactionType}_rtl` : transactionType;

export interface FieldRearrangementConfigStorage {
  positions: Record<string, string>;
  hidden: string[];
  shown: string[];
  locked: string[];
}

/** All configs for a company, keyed by transaction type */
export type AllConfigsStorage = Record<string, FieldRearrangementConfigStorage>;

export interface JeFieldRearrangementState {
  configsByType: Map<string, FieldRearrangementConfigStorage>;
}

export interface SwapCellsPayload {
  fieldNameA: string;
  pairIdA: string;
  fieldNameB: string | null;
  pairIdB: string;
}

export interface CellFieldPayload {
  fieldName: string;
}

export interface FieldRearrangementAction<T = unknown> {
  type: string;
  payload: T;
}
